import { Fancybox } from "@fancyapps/ui";

/**
 * ProductBlockGallery
 * ======================================
 * - mobile only
 * - add class to parent on click
 * - and close others open on mobile
 */

const ISMOBILE = window.matchMedia("only screen and (max-width: 768px)").matches
const WIDGET = '.js-ProductBlockGallery'
const ACTIVECLASS = 'is-active'

class ProductBlockGallery {
  constructor() {
    this.elements = document.querySelectorAll(WIDGET)

    if(!this.elements){
      return
    }

    if(ISMOBILE){
      Fancybox.bind("[data-fancybox-product-block]", {
        groupAttr: 'data-fancybox-product-block'
      });

      return
    }

    this.elements.forEach((el) => {
      const previews = el.querySelectorAll('.product-block__carousel-item')

      previews.forEach((preview) => {
        preview.addEventListener('click', this.clickHandler)
      })
    })
  }

  getIndex = (el) => {
    return [...el.parentNode.children].indexOf(el)
  }

  clickHandler = (e) => {
    const button = e.currentTarget
    const widget = button.closest(WIDGET)

    this.closeActive(widget)

    widget.querySelector('.product-block__img-item:nth-child('+(this.getIndex(button) + 1)+')').classList.add(ACTIVECLASS)

    e.preventDefault()
  }

  closeActive = (widget) => {
    const active = widget.querySelector('.product-block__img-item.'+ACTIVECLASS)
    active.classList.remove(ACTIVECLASS)
  }
}

new ProductBlockGallery()
